<template>
  <article class="fareItem">
    <header class="fareItem__head">
      <div class="fareItem__title">{{ ffamFareItem.name }}</div>
    </header>
    <section class="fareItem__body">
      <div
        class="fareItem__feat"
        v-for="(service, key) in orderedConditions"
        :key="key"
      >
        <div :class="`fareItem__featIcon --${service.condition}`">
          <i class="fas" :class="getIconByService(service)"></i>
          <!-- <i :class="`fas fa-backpack`"></i> -->
        </div>
        <div class="fareItem__featLabel">
          <span v-html="normalizedName(service.sub_code)"></span>
        </div>
      </div>
    </section>
    <article>
      <div v-if="showMoreDetails" class="fareItem__moreDetails">
        <span v-html="this.$t('shopping_lib.ffam_more_details')"></span>
        <i class="fas fa-chevron-right"></i>
      </div>
      <div
        class="fareItem__places"
        v-if="hasSomeFareItemPosting"
        :style="showOrHideElement"
      >
        <span>
          <i class="fa-solid fa-triangle-exclamation"></i>
          {{ seatsRemaining(ffamFareItem) }}
        </span>
      </div>
      <FareItemInformation
        :minimumPrice="minimumPriceToCompare?.total"
        :currency="ffamFareItem.fare_information?.currency_reference_id"
        :amount="fareItemPrice"
        :displayFullPrices="displayFullPrices"
      >
      </FareItemInformation>
      <div class="fareItem__button">
        <button class="btn btn-primary" @click="$emit('onFareSelected')">
          {{ $t('shopping_lib.select') }}
        </button>
        <span class="fareItem__buttonSelected">{{
          $t('shopping_lib.fare_selected')
        }}</span>
      </div>
    </article>
  </article>
</template>
<script>
import FareItemInformation from './fareItemInformation.vue'
export default {
  name: 'uppsellingFareItem',
  components: { FareItemInformation },
  inject: ['configurations'],
  props: {
    ffamFareItem: {
      type: Object,
      required: true,
    },
    tripSegment: {
      type: Number,
      required: true,
    },
    minimumPriceToCompare: {
      type: Object,
      required: false,
    },
    hasSomeFareItemPosting: {
      type: Boolean,
      required: false
    }
  },
  methods: {
    getIconByService(service) {
      if (service.icon) return 'fa-' + service.icon
      return {
        'fa-x': service.condition === 'not_included',
        'fa-dollar-sign': service.condition === 'charges_apply',
        'fa-check': service.condition === 'free',
      }
    },
    seatsRemaining: function (ffamFareItem) {
      const seats = ffamFareItem?.fare_information?.rbd?.posting
      if (seats >= 2) return `${seats} ${this.$t(`lasts`)}`
      else return this.$t('last_seat')
    },
    normalizedName(code) {
      return this.$t(`shopping_lib.sub_code_${code}`)
    },
  },
  computed: {
    showMoreDetails () {
      return this.$t('shopping_lib.ffam_more_details') !== 'shopping_lib.ffam_more_details'
    },
    fareItemPrice: function () {
      const amount =
        this.ffamFareItem.fare_information?.trip_segment_prices[
          this.tripSegment
        ].total
      if (this.displayFullPrices) return amount
      return amount - this.minimumPriceToCompare.total
    },
    isMinimumPrice: function () {
      return !this.minimumPriceToCompare
    },
    displayFullPrices: function () {
      return (
        !this.minimumPriceToCompare || this.configurations.displayFullPrices
      )
    },
    orderedConditions: function () {
      if (this.configurations.upsellingConditionsAlphabetically) {
        const conditions =
          this.ffamFareItem.fare_information.trip_segment_services[
            this.tripSegment
          ]
        return conditions.sort((itemA, itemB) =>
          itemA.sub_code.localeCompare(itemB.sub_code)
        )
      } else {
        return this.ffamFareItem.fare_information.trip_segment_services[
          this.tripSegment
        ]
      }
    },
    showOrHideElement: function () {
      return {
        visibility: this.ffamFareItem.fare_information?.rbd.posting < 9 ? 'visible' : 'hidden'
      }
    }
  },
}
</script>

<style lang="sass">

.fareItem
  border-radius: var(--b-radius-lg)
  border: 1px solid var(--color-overlay-30)
  background-color: var(--color-surface)
  color: var(--color-onSurface)
  display: flex
  flex-direction: column
  flex: 1
  transition: border .2s ease
  &__buttonSelected
    display: none
  &.--active
    border: 1px solid var(--color-primary)
    .fareItem__select
      // background-color: var(--color-primary)
      // color: var(--color-onPrimary)
    .fareItem__head
      border-top: 1rem solid var(--color-primary)
    .fareInformation__checkmark
      box-shadow: inset 0 0 0 0.35rem var(--color-onPrimary)
    .fareItem__button .btn
      display: none
    .fareItem__buttonSelected
      display: block
      text-align: center
      padding: .5rem 1rem 0.75rem 1rem
      font-weight: 700
  &.--disabled
    background-color: transparent
    pointer-events: none
    .fareItem__price
      font-size: var(--font-size-md)
    .fareItem__select
      background-color: var(--color-overlay-10)
  &:hover
    border: 1px solid var(--color-primary)
  &:not(.--active)
    &.__button
      cursor: pointer
.fareItem__head
  display: flex
  width: 100%
  padding: 0 2rem
  // justify-content: center
  border-radius: var(--b-radius-lg)
  border-top: 1rem solid var(--color-overlay-10)
.fareItem__places
  padding: 0.25rem 1rem
  span
    background-color: rgba(255, 215, 0, 0.1)
    padding: .25rem .75rem
    border-radius: 0.1875rem
    display: block
    font-size: .8rem
    text-align: center
  // width: 100%
.fareItem__body
  display: flex
  flex-direction: column
  flex: 1
  // border-top: 1px solid var(--color-overlay-30)
  // background-color: var(--color-overlay-02)
.fareItem__feat
  display: flex
  // align-items: center
  padding: .3rem 1rem
  gap: 1rem
  &Icon
    &.--free
      background-color: var(--color-success)
    &.--charges_apply
      background-color: var(--color-error)
    &.--not_included
      background-color: var(--color-overlay-10)
  // &.--not
  //   .fareItem__featLabel
  //     opacity: .7
  //   .fareItem__featIcon
  //     color: var(--color-onSurface)
  //     opacity: .4
  //     i:before
  //       content: "\f00d"
  // &:not(.--not)
  //   .fareItem__featIcon
  //     background-color: var(--color-success)
.fareItem__title
  font-size: var(--font-size-smd)
  font-weight: bold
  padding: .5rem 0
.fareItem__button
  // width: 100%
  padding: 0rem 1rem 0.75rem 1rem
  .btn
    width: 100%
    font-weight: 500
.fareItem__featLabel
  font-size: var(--font-size-sbase)
  font-weight: bold
  a
    color: var(--color-primary)
    font-size: var(--font-size-sbase)
    font-weight: 500
    text-decoration: underline
    &:hover
      color: var(--color-secondary)
.fareItem__featIcon
  font-size: var(--font-size-sbase)
  display: flex
  align-items: center
  justify-content: center
  height: 1.75rem
  min-width: 1.75rem
  border-radius: 50%
  color: var(--color-onSuccess)
.fareItem__select
  display: flex
  width: 100%
  align-items: flex-start
  .fareInformation
    margin: 0
    width: 100%
  .fareInformation__container
    padding: .5rem 1rem 0 1.25rem
    display: flex
    flex-direction: column
    justify-content: flex-end
  .fareInformation__label
    display: flex
    flex-wrap: wrap
    align-items: baseline
    font-weight: 700
    gap: .5rem
    color: var(--color-primary)
  .fareInformation__prevPrice
    font-weight: 700
    color: var(--color-onSurface)
    font-size: var(--font-size-sbase)
    gap: 1px
.fareItem__calculator
  font-size: var(--font-size-md)
.fareItem__price
  font-size: var(--font-size-lg)
  margin-left: .2rem
.fareItem__currency
  font-size: var(--font-size-md)
.fareItem__selectInfo
  font-size: var(--font-size-sm)
  width: 100%
.fareItem__moreDetails
  margin: 0.25rem 1rem 0.25rem 1rem
  display: flex
  padding: 8px 24px
  justify-content: center
  align-items: center
  gap: 12px
  align-self: stretch
  border-radius: 4px
  background: var(--overlay-05, rgba(33, 33, 33, 0.05))
  a
    color: var(--color-primary)
    font-size: var(--font-size-sbase)
    text-decoration: none
    font-weight: 600
    &:hover
      color: var(--color-primary)
      text-decoration: none
  i
    color: var(--color-primary)
    display: flex
    align-items: center
    justify-content: center
</style>
